import api from "@/api/apiConfig"
import {
  Post,
  Get
} from './base/baseAjax'
let getCheckManage = (param) => {
  return Post({
    url: api.check.getCheckManage,
    bodyParam: param
  })
}
let setCheckRecord = (param) => {
  return Post({
    url: api.check.setCheckRecord,
    bodyParam: param
  })
}
let getTime = (param) => {
  return Get({
    url: api.check.getTime,
    PathParam: param
  })
}
let getCheckRecord = (param) => {
  return Post({
    url: api.check.getCheckRecord,
    bodyParam: param
  })
}
let getRules = () => {
  return Get({
    url: api.check.getRules
  })
}
let addRules = (param) => {
  return Post({
    url: api.check.addRules,
    bodyParam: param
  })
}
let editRules = (param) => {
  return Post({
    url: api.check.editRules,
    bodyParam: param
  })
}
let deleteRules = (param) => {
  return Get({
    url: api.check.deleteRules,
    PathParam: param
  })
}


export default {
  getCheckManage,
  setCheckRecord,
  getTime,
  getCheckRecord,
  getRules,
  addRules,
  editRules,
  deleteRules
}



// WEBPACK FOOTER //
// ./src/services/check.js